import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { NewStoryService } from '../new/new.service';
import { find, sortBy } from 'lodash';
import { FirebaseService } from 'app/services/firebase.service';
import { Observable } from 'rxjs';

@Injectable()
export class UploadWizardService {
  private baseUrl = environment.API;
  filteringLevels;
  occasions;
  styles;
  bookformats;
  decorations;
  densities;
  stickerDensities;
  specs;
  details;
  designOptionsApplied = false;

  isLoadingStyles = false;

  constructor(
    private http: HttpClient,
    private newStory: NewStoryService,
    private firebaseService: FirebaseService
  ) {
    this.initializeWizard();
    this.newStory.onUploadReset.subscribe(() => {
      this.initializeWizard();
    });
  }

  private getDefaultItem(collection) {
    return find(collection, { is_default: true }) || collection[0];
  }
  private getDefaultStickerDensity(collection) {
    return find(collection, { slug: 'few' }) || collection[0];
  }

  public applyDesignOptions(designOptions) {
    // Occasions
    this.occasions = [...designOptions.occasions];
    // this.specs.occasion = this.specs.occasion || this.occasions[0].slug;
    this.specs.occasion = this.specs.occasion || null;
    this.getStyles(this.specs.occasion);

    // Bookformats
    this.bookformats = [...designOptions.book_formats];
    if (this.bookformats.length) {
      if (!this.specs.book_format) {
        this.firebaseService.meta.albumSize = this.getDefaultItem(
          this.bookformats
        ).name;
      }
      this.specs.book_format =
        this.specs.book_format || this.getDefaultItem(this.bookformats).id;
    }

    // Sticker Densities
    this.stickerDensities = [...designOptions['text_sticker_levels']];
    const stickerDensity = this.getDefaultStickerDensity(this.stickerDensities);
    this.specs.text_sticker_level = this.specs.text_sticker_level || stickerDensity.slug;

    // Densities

    this.densities =
      this.bookformats[this.formatSelected] ?
      this.bookformats[this.formatSelected]['densities'] :
      this.bookformats[0]['densities'];

    const density = this.getDefaultItem(this.densities);
    this.details.discount_code =
      (density.discount && density.discount.discount_code) || '';
    if (!this.specs.image_density) {
      const minCount = density.min_image_count;
      const maxCount = density.max_image_count;
      this.firebaseService.meta.albumPicsVolume =
        minCount === maxCount ? minCount : `${minCount}-${maxCount}`;
    }

    this.specs.image_density = this.specs.image_density || density.slug;
    this.designOptionsApplied = true;
  }

  // todo check, probably not using
  public getFilteringLevels() {
    const url = `${this.baseUrl}/imagefilteringlevels/`;

    this.http.get(url).subscribe(
      data => {
        this.filteringLevels = sortBy(data['results'], 'position');
        this.specs.image_filtering_level =
          this.specs.image_filtering_level ||
          this.getDefaultItem(this.filteringLevels).slug;
      },
      data => {
        // Handle error
      }
    );
  }

  private clearSelectedStyle() {
    const containsSelectedStyle = find(this.styles, style => {
      return this.specs.style === style.slug;
    });
    if (!containsSelectedStyle) {
      this.specs.style = '';
    }
  }

  public getStyles(occasionSlug?) {
    if (occasionSlug) {
      this.styles = this.occasions.find(
        occasion => occasion.slug === occasionSlug
      ).styles;
      this.clearSelectedStyle();
      this.specs.style = this.specs.style || this.styles[0].slug;
    }
    this.isLoadingStyles  = false;
    // else {
    //   this.styles = this.occasions.reduce((acc: [], occasion) => {
    //     return acc.concat(occasion.styles);
    //   });
    // }

  }

  // getAllStyles(): Observable<any> {
  //   const url = `${this.baseUrl}/styles/`;
  //   return this.http.get(url);
  // }

  loadDesignOptions(discountCode) {
    const url = `${this.baseUrl}/designoptions/project/${this.newStory.projectId}`;
    const params = discountCode
      ? new HttpParams().set('discount', discountCode)
      : new HttpParams();

    return this.http.get(url, { params });
  }

  selectFormat(index) {
    const bookformat = this.bookformats[index];
    this.firebaseService.meta.albumSize = bookformat.name;
    this.specs.book_format = bookformat.id;
    this.densities = [...bookformat['densities']];
  }

  get formatSelected() {
    return this.bookformats.findIndex(
      bookformat => bookformat.id === this.specs.book_format
    );
  }

  public getDecorations() {
    const { style } = this.specs;

    this.decorations = this.styles.find(
      item => item.slug === style
    ).embellishment_levels;

    this.specs.embellishment_level =
      this.specs.embellishment_level ||
      this.getDefaultItem(this.decorations).slug;
  }

  private initializeWizard() {
    this.specs = {
      book_format: '',
      image_filtering_level: '',
      embellishment_level: '',
      image_density: '',
      text_sticker_level: '',
      occasion: '',
      style: '',
    };

    this.details = {
      title: '',
      subtitle: '',
      instructions: '',
      design_mode: 'automatic',
      discount_code: '',
    };
  }

  public cleanWizard() {
    this.styles = [];
    this.occasions = [];
    this.specs = {
      book_format: '',
      image_filtering_level: '',
      embellishment_level: '',
      image_density: '',
      text_sticker_level: '',
      occasion: '',
      style: '',
    };
  }
}
